import PropTypes from 'prop-types';

export const glossaryListProps = PropTypes.arrayOf(
  PropTypes.shape({
    slug: PropTypes.string.isRequired,
    page: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }),
  })
).isRequired;

export const glossaryListType = PropTypes.shape({ ...glossaryListProps });
